export const PAYMENT_REDIRECT_PATH = '/payment/redirect_3ds';
export const PAYMENT_REDIRECT_IFRAME_3DS_DATA = 'LT_Payment3dsData';
